import styled from "styled-components";

export const Viewer = styled.div`
  position: relative;
  //height: 40px;
  text-align: center;
  margin-bottom: 20px;
  padding: 30px 30px 0;
`
export const Layout = styled.div`
  margin-bottom: 40px;
`;

export const LayoutHeader = styled.h3`
  padding: 10px;
  font-size: 20px;
  text-align: center;
  color: #555;
  margin-bottom: 10px;
  margin-top: 20px;
  
`;
export const LayoutContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;